import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TranslateLoader } from '@ngx-translate/core';

import { environment } from 'environments/environment';

export class EcomTranslationHttpLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`${environment.apiHost}api/i18n/${lang}`);
  }
}
